export interface AppCompatibility {
	minimumAppVersion: string | null;
	isAppVersionSupported: boolean | null;
}

export function buildAppVersionHealthUrl(endpoint: string, appVersion: string): string {
	const separator = endpoint.includes('?') ? '&' : '?';
	return `${endpoint}${separator}appVersion=${encodeURIComponent(appVersion)}`;
}

export function extractAppCompatibility(response: unknown): AppCompatibility {
	const data = response && typeof response === 'object' ? (response as Record<string, unknown>) : {};

	return {
		minimumAppVersion: typeof data.minimumAppVersion === 'string' ? data.minimumAppVersion : null,
		isAppVersionSupported:
			typeof data.isAppVersionSupported === 'boolean' ? data.isAppVersionSupported : null,
	};
}
